import { render, staticRenderFns } from "./2.priceSelectionOptions.event-registration.vue?vue&type=template&id=f973c65e"
import script from "./2.priceSelectionOptions.event-registration.vue?vue&type=script&lang=ts"
export * from "./2.priceSelectionOptions.event-registration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports